(function () {
  /**
   * 顶部菜单栏当鼠标hover Products 时 显示二级菜单栏
   */
  function showSubmenu() {
    // 找到所有的header__dropdown__inner
    const headerDropdownInner = document.querySelectorAll(
      '.header__dropdown__inner'
    );

    // 获取所有的product__list
    const productLists = document.querySelectorAll('.product__list');

    const windowSubMenuItems = [];

    // 判断该header__dropdown__inner是否包含类名为sub__menu__wrapper的子节点
    headerDropdownInner.forEach((item, index) => {
      // 获取header__dropdown__inner的子元素
      const children = Array.from(item.children);
      // 判断子元素的子元素是否包含sub__menu__wrapper的子节点
      const hasSubMenu = children.some((child) =>
        child.classList.contains('sub__menu__wrapper')
      );
      if (hasSubMenu) {
        headerDropdownInner[index].classList.add('has__sub__menu');
        // 更新数组
        windowSubMenuItems.push(index);
      }
    });

    window.windowSubMenuItems = windowSubMenuItems;

    const mobileDoms = document.querySelector('.header__mobile');
    const mobileDisplay = window.getComputedStyle(mobileDoms).display;

    // 找到所有的sub__menu__item
    const subMenuItems = document.querySelectorAll('.sub__menu__item');

    // 找到所有的sub__menu__product__wrapper
    const productWrapper = document.querySelectorAll(
      '.sub__menu__product__wrapper'
    );

    // 将所有的sub__menu__item移除类名sub__menu__item__active
    const delSubMenuClass = () => {
      subMenuItems.forEach((item) => {
        item.classList.remove('sub__menu__item__active');
      });
    };

    // 将所有的sub__menu__product__wrapper的opacity设置成0
    const delProductWrapperOpacity = () => {
      productWrapper.forEach((item) => {
        item.style.opacity = 0;
        item.style.zIndex = 1;
        item.classList.remove('show__pc__product__wrapper');
      });
    };

    let boxEl = document.querySelector('.header__wrapper');
    if (mobileDisplay !== 'none') {
      // document.querySelector('.subfooter__item').style.display = 'none';
      boxEl.style.zIndex = 453;
    } else {
      productWrapper[0].style.zIndex = 2;
      productWrapper[0].style.opacity = 1;
      productWrapper[0].classList.add('show__pc__product__wrapper');
      subMenuItems[0].classList.add('sub__menu__item__active');
    }

    let x = window.matchMedia("(min-width: 769px)");
    if (x.matches) {
      boxEl.style.zIndex = '';
    }

    // 给sub__menu__item增加鼠标移入事件;
    subMenuItems.forEach((item, index) => {
      if (mobileDisplay === 'none') {
        item.addEventListener('pointerenter', () => {
          delSubMenuClass();
          delProductWrapperOpacity();
          item.classList.add('sub__menu__item__active');
          productWrapper[index].style.opacity = 1;
          productWrapper[index].style.zIndex = 2;
          productWrapper[index].classList.add('show__pc__product__wrapper');
        });
      } else {
        item.addEventListener('click', (e) => {
          delSubMenuClass();
          delProductWrapperOpacity();

          if (item.classList.contains('sub__menu__mobile__active')) {
            item.classList.remove('sub__menu__mobile__active');
          } else {
            subMenuItems.forEach((items) => {
              items.classList.remove('sub__menu__mobile__active');
            });
            item.classList.add('sub__menu__mobile__active');
          }

          if (productWrapper[index].classList.contains('mobile_visible')) {
            productWrapper[index].classList.remove('mobile_visible');
          } else {
            productWrapper.forEach((item) => {
              item.classList.remove('mobile_visible');
            });
            productWrapper[index].classList.add('mobile_visible');
          }
        });
      }
    });

    productLists.forEach((item) => {
      const aList = item.querySelectorAll('.product__item__a');
      aList.forEach((item, index) => {
        item.style.transitionDelay = `${index * 50 + 10}ms`;
      });
    });
  }

  function copySku() {
    async function copyTextToClipboard(text) {
      try {
        // 耗时操作200ms
        await new Promise((resolve) => setTimeout(resolve, 500));
        await navigator.clipboard.writeText(text);
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    }
    // 找到countdown-timer-copy
    const copySku = document.querySelector('.countdown-timer-copy');
    // 找到sku
    const sku = document.querySelector('.countdown-timer-sku');
    if (copySku && sku) {
      copySku.addEventListener('click', async () => {
        // 获取到.countdown-timer-copy-btn
        const copyBtn = document.querySelector('.countdown-timer-copy-btn');
        // 获取到.countdown-timer-copy
        const copyWrap = document.querySelector('.countdown-timer-copy');
        copyWrap.style.color = 'rgba(235, 95, 84, 1)';
        copyBtn.classList.add('loading');
        await copyTextToClipboard(sku.innerText);
        copyBtn.classList.remove('loading');
        copyBtn.classList.add('has-success');
        await new Promise((resolve) => setTimeout(resolve, 500)).then(() => {
          copyBtn.classList.remove('has-success');
          copyWrap.style.color = '#fff';
        });
      });
    }
  }

  function showFooter() {
    //找到product__submit__buttons
    const productSubmitButtons = document.querySelector(
      '.product__submit__buttons'
    );
    // 找到footer_bar__quick
    const footerBarQuick = document.querySelector('.footer_bar__quick');
    // 找到product-navigation
    const productNavigation = document.querySelector('.product-navigation');
    // 获取productNavigation的高度
    const productNavigationHeight = productNavigation.offsetHeight;

    // 监听页面滚动事件
    window.addEventListener('scroll', () => {
      if (productSubmitButtons) {
        // 当productSubmitButtons的底部距离顶部的距离小于等于productNavigation的高度时footerBarQuick的display设置成none
        if (
          productSubmitButtons.getBoundingClientRect().bottom <=
          productNavigationHeight
        ) {
          footerBarQuick.style.display = 'block';
        } else {
          footerBarQuick.style.display = 'none';
        }
      }
    });
  }

  function combos() {
    // 找到到所有的product-look
    const lookSection = document.querySelectorAll('.look-section');
    // 找到look-tabs下的li
    const lookTabsLi = document.querySelectorAll('.look-tabs li');
    // 找到section-custom-tabs下的li
    const customTabsLi = document.querySelectorAll('.section-custom-tabs li');
    // 找到所有的look-hero
    const lookHero = document.querySelectorAll('.look-hero');
    // 找到所有的look-tabs
    const lookTabs = document.querySelectorAll('.look-tabs');
    // 找到高度，第一个.look-section 下的.flickity-viewport的height
    const height =
      lookSection[0]?.querySelector('.flickity-viewport')?.offsetHeight;
    const height2 = lookSection[0]?.querySelector(
      '.combos-mini-cart .flickity-viewport'
    )?.offsetHeight;

    // 给customTabsLi增加点击事件
    customTabsLi.forEach((item, index) => {
      if (index === 0) {
        item.classList.add('checked');
      }
      item.addEventListener('click', () => {
        customTabsLi.forEach((li) => {
          li.classList.remove('checked');
        });
        customTabsLi[index].classList.add('checked');

        // 全部display none
        lookSection.forEach((section) => {
          // section.style.display = 'none';
          section.style.visibility = 'hidden';
          section.style.height = '0px';
          section.style.overflow = 'hidden';
        });

        // 第一个`look-section-group${index+1}`display block
        const temp = document.querySelectorAll(
          `.look-section-group${index + 1}`
        );

        const isOpen = temp[0]?.getAttribute('data-slider_enable') === 'true';

        // 判断是block第一个还是全部block
        if (!isOpen) {
          temp.forEach((item) => {
            // item.style.display = 'block';
            item.style.visibility = 'visible';
            item.style.height = 'auto';
          });
        } else {
          // temp[0].style.display = 'block';
          temp[0].style.visibility = 'visible';
          temp[0].style.height = 'auto';
        }

        // 第一个`look-section-group${index+1}` 下的.flickity-viewport设置高度
        if (!isOpen) {
          temp.forEach((item) => {
            item.querySelector('.flickity-viewport').style.height =
              height + 'px';

            if (item.querySelector('.combos-mini-cart .flickity-viewport')) {
              item.querySelector(
                '.combos-mini-cart .flickity-viewport'
              ).style.height = height2 + 'px';
            }
          });
        } else {
          temp[0].querySelector('.flickity-viewport').style.height =
            height + 'px';
          if (temp[0].querySelector('.combos-mini-cart .flickity-viewport')) {
            temp[0].querySelector(
              '.combos-mini-cart .flickity-viewport'
            ).style.height = height2 + 'px';
          }
        }

        // 隐藏全部二级导航
        lookTabs.forEach((tabs) => {
          tabs.style.display = 'none';
        });
        // 对应二级导航显示
        if (lookTabs[index]) {
          if (isOpen) {
            lookTabs[index].style.display = 'block';
            lookTabsLi.forEach((li) => {
              li.classList.remove('checked');
            });
            // 第index个.look-tabs下的第一个li 选中
            document
              .querySelectorAll('.look-tabs')
              [index].querySelectorAll('li')[0]
              .classList.add('checked');
          } else {
            lookTabsLi.forEach((li) => {
              li.classList.remove('checked');
            });
          }
        }
        toggleLookHero();
      });
    });

    const first = document.querySelector('.look-section-group1');
    const firstAll = document.querySelectorAll('.look-section-group1');

    if (first?.getAttribute('data-slider_enable') === 'false') {
      lookSection.forEach((item, index) => {
        // item.style.display = 'none';
        item.style.visibility = 'hidden';
        item.style.height = '0px';
        item.style.overflow = 'hidden';
      });
      // 第一个系列全部display block
      firstAll.forEach((item) => {
        // item.style.display = 'block';
        item.style.visibility = 'visible';
        item.style.height = 'auto';
      });
    } else {
      // 全部display none 第一个 block
      lookSection.forEach((item, index) => {
        if (index === 0) {
          item.style.visibility = 'visible';
          item.style.height = 'auto';
        } else {
          item.style.visibility = 'hidden';
          item.style.height = '0px';
          item.style.overflow = 'hidden';
        }
      });
    }

    lookTabs.forEach((tabs, index) => {
      if (index === 0 && first?.getAttribute('data-slider_enable') === 'true') {
        tabs.style.display = 'block';
      }
    });

    // 给lookTabsLi增加点击事件显示对应的lookSection
    lookTabsLi.forEach((item, index) => {
      // 第一个lookTabsLi默认选中
      if (index === 0) {
        item.classList.add('checked');
      }
      item.addEventListener('click', () => {
        lookTabsLi.forEach((li) => {
          li.classList.remove('checked');
        });
        lookSection.forEach((section) => {
          section.style.visibility = 'hidden';
          section.style.height = '0px';
          section.style.overflow = 'hidden';
        });
        lookTabsLi[index].classList.add('checked');

        lookSection[index].style.visibility = 'visible';
        lookSection[index].style.height = 'auto';
        // 给第i个.look-section 下的.flickity-viewport设置高度
        lookSection[index].querySelector('.flickity-viewport').style.height =
          height + 'px';

        toggleLookHero();
      });

      toggleLookHero();
    });

    function toggleLookHero() {
      lookHero.forEach((item) => {
        const broChild =
          item.parentElement.parentElement.parentElement.parentElement;

        const cls =
          item.parentElement.parentElement.parentElement.parentElement;

        const preDom = document.querySelector(
          `.${cls.classList[1]}`
        ).previousElementSibling;

        const style = window.getComputedStyle(broChild);
        item.style.display = style.display;
        if (preDom) {
          if (window.getComputedStyle(preDom).display === 'block') {
            const height = Number(
              window.getComputedStyle(preDom).height.replace('px', '')
            );
            if (document.documentElement.clientWidth > 768) {
              item.style.top = `${height + 65 + 45}px`;
            } else {
              item.style.top = `${height + 30}px`;
            }
          }
        }
      });
    }

    toggleLookHero();
  }

  function expore() {
    // 获取所有的platform-tab下的div
    const platformTabDiv = document.querySelectorAll(
      '.platform-tab .type-platform '
    );
    // 获取所有的tabpanel
    const tabPanel = document.querySelectorAll('.platform-wrapper .tabpanel');

    // 找到高度，第一个.look-section 下的.flickity-viewport的height
    const height =
      tabPanel[0]?.querySelector('.flickity-viewport')?.offsetHeight;

    tabPanel.forEach((item, index) => {
      if (index === 0) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });

    platformTabDiv.forEach((item, index) => {
      if (index === 0) {
        item.classList.add('checked');
      }
      item.addEventListener('click', () => {
        platformTabDiv.forEach((div) => {
          div.classList.remove('checked');
        });
        platformTabDiv[index].classList.add('checked');
        tabPanel.forEach((panel) => {
          panel.style.display = 'none';
        });
        tabPanel[index].style.display = 'block';
        if (tabPanel[index].querySelector('.flickity-viewport')) {
          tabPanel[index].querySelector('.flickity-viewport').style.height =
            height + 'px';
        }
      });
    });
  }

  function timeline() {
    if (!document.querySelector('.section-timeline')) {
      return;
    }

    const timelineYearWrapper = document.querySelectorAll(
      '.timeline-year-wrapper'
    );

    // 获取屏幕宽度
    const screenWidth = document.documentElement.clientWidth;

    // 获取.timeline-line-dot-wrapper
    const timelineDotWrapper = document.querySelector(
      '.timeline-line-dot-wrapper'
    );

    // 获取.timeline-line-line
    const timelineLine = document.querySelector('.timeline-line-line');

    // 获取content-wrapper-out
    const contentWrapperOut = document.querySelector('.content-wrapper-out');

    // 个数
    const count = timelineYearWrapper.length;

    // 获取年份的宽度
    const yearWidth = timelineYearWrapper[0].clientWidth;

    // 初始间距
    const initMove = screenWidth / 2 - yearWidth / 2;

    // 间距
    let gap;
    if (screenWidth > 680) {
      gap = 187;
    } else {
      gap = 20;
    }

    // 每个的间距
    const moveGap = gap + yearWidth;

    // 坐标
    let current = 0;

    // 修改timelineLine的宽度
    timelineLine.style.width = `${(yearWidth + gap) * (count - 1)}px`;
    timelineLine.style.left = `${yearWidth / 2}px`;

    // 修改timelineDotWrapper初始位置
    timelineDotWrapper.style.transform = `translateX(${initMove}px)`;

    function moveTo(index) {
      const now = initMove - index * (yearWidth + gap);
      timelineDotWrapper.style.transform = `translateX(${now}px)`;
      contentWrapperOut.style.transform = `translateX(-${
        index * screenWidth
      }px)`;
      contentWrapperOut.style.transitionDuration = '0.5s';
      btnStatus(index);
    }

    // 获取.text-next-btn
    const textNextBtn = document.querySelector('.text-next-btn');

    // 获取.text-prev-btn
    const textPrevBtn = document.querySelector('.text-prev-btn');

    timelineYearWrapper.forEach((item, index) => {
      if (index === 0) {
        item.classList.add('checked');
      }
    });

    // 判断按钮的禁用状态
    function btnStatus(index) {
      if (index <= 0) {
        textPrevBtn.classList.add('disabled');
      } else if (index >= count - 1) {
        textNextBtn.classList.add('disabled');
      } else {
        textPrevBtn.classList.remove('disabled');
        textNextBtn.classList.remove('disabled');
      }
    }

    btnStatus(0);

    function changeClass(index) {
      timelineYearWrapper.forEach((item) => {
        item.classList.remove('checked');
      });

      timelineYearWrapper[index].classList.add('checked');
    }

    textNextBtn.addEventListener('click', () => {
      if (current >= count - 1) {
        return;
      }
      changeClass(current + 1);
      moveTo(current + 1);
      current++;
    });

    textPrevBtn.addEventListener('click', () => {
      if (current <= 0) {
        return;
      }
      changeClass(current - 1);
      moveTo(current - 1);
      current--;
    });

    let isDragging = false;
    let offsetX;
    let now;
    let over;

    function dragOver(params) {
      if (params > initMove) {
        moveTo(0);
        changeClass(0);
        current = 0;
      } else {
        // 判断最近的节点
        let realMove = Math.round((initMove - params) / moveGap);
        realMove = Math.min(realMove, count - 1);
        moveTo(realMove);
        changeClass(realMove);
        current = realMove;
      }
    }

    // 鼠标拖动事件
    timelineDotWrapper.addEventListener('mousedown', (e) => {
      isDragging = true;
      timelineDotWrapper.classList.add('draging');
      // 获取当前鼠标位置
      offsetX = e.clientX;
      now = parseInt(
        timelineDotWrapper.style.transform
          .split('(')[1]
          .split(')')[0]
          .split(',')[0]
      );
      over = now;
    });

    timelineDotWrapper.addEventListener('mousemove', (e) => {
      if (isDragging) {
        over = now + e.clientX - offsetX;
        timelineDotWrapper.style.transform = `translateX(${over}px)`;
      }
    });

    timelineDotWrapper.addEventListener('mouseup', () => {
      timelineDotWrapper.classList.remove('draging');
      dragOver(over);
      isDragging = false;
      timelineDotWrapper.style.cursor = 'grab';
    });
  }

  function industry() {
    let flag = true;
    const industryDom = document.querySelector('.section-industry');
    if (!industryDom) {
      return;
    }
    // 获取所有的industry-num
    const industryNum = document.querySelectorAll('.industry-num');

    // industryNum.forEach((item) => {
    //   item.innerHTML = 0;
    // });
    // 给滚动事件添加节流
    function throttle(fn, delay) {
      let last = 0;
      return function () {
        const now = Date.now();
        if (now - last > delay) {
          fn();
          last = now;
        }
      };
    }

    function numAdd() {
      if (!flag) {
        return;
      }
      flag = false;
      industryNum.forEach((item) => {
        const targetNum = item.innerHTML;
        // 总时间2000毫秒
        let nums = 0;
        let speed = 1;
        if (Number(targetNum) >= 2) {
          speed = 2;
        }
        if (Number(targetNum) >= 1000) {
          speed = 5;
        }
        const st = setInterval(() => {
          if (nums < targetNum) {
            item.innerHTML = Math.min(nums + speed, targetNum);
            nums += speed;
          } else {
            item.innerHTML = targetNum;
            clearInterval(st);
          }
        }, (2000 / targetNum) * speed);
      });
    }

    window.addEventListener(
      'scroll',
      throttle(function () {
        //  判断targetDom是否滚动到窗口顶部
        if (window.scrollY >= industryDom.offsetTop - 300) {
          numAdd();
        }
      }, 200)
    );
  }

  function ceo(params) {
    const ceoDom = document.querySelector('.section-aqara-ceo');
    if (!ceoDom) {
      return;
    }
    const aSection = document.querySelector('.aqara-ceo-a-section');
    const bSection = document.querySelector('.aqara-ceo-b-section');

    let current = 0;

    let canToggleDown = true;
    let canToggleUp = false;

    let inSide = false;

    aSection.classList.add('sectionShow');

    function toggleShow(params) {
      if (params === 'down') {
        aSection.classList.remove('sectionShow');
        bSection.classList.add('sectionShow');
      } else {
        aSection.classList.add('sectionShow');
        bSection.classList.remove('sectionShow');
        canToggleDown = true;
      }
    }

    // 禁止滚动
    function preventDefault(e) {
      e.preventDefault();
    }

    function disableScroll() {
      document.addEventListener('wheel', preventDefault, { passive: false });
      document.addEventListener('touchmove', preventDefault, {
        passive: false,
      });
    }

    // 允许滚动
    function enableScroll() {
      document.removeEventListener('wheel', preventDefault);
      document.removeEventListener('touchmove', preventDefault);
    }

    document.addEventListener('scroll', (e) => {
      if (window.scrollY <= 0) {
        canToggleUp = true;
      }
    });

    ceoDom.addEventListener('mouseleave', () => {
      inSide = false;
    });

    ceoDom.addEventListener('wheel', (event) => {
      // 获取滚动容器相对于视口的位置
      const rect = ceoDom.getBoundingClientRect();

      // 获取鼠标相对于滚动容器的坐标
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;

      // 判断鼠标是否在滚动容器内
      const isInside =
        mouseX >= 0 &&
        mouseX <= ceoDom.offsetWidth &&
        mouseY >= 0 &&
        mouseY <= ceoDom.offsetHeight;

      if (isInside) {
        inSide = true;
        if (event.deltaY > 0 && canToggleDown) {
          disableScroll();
          canToggleDown = false;
          toggleShow('down');
          setTimeout(() => {
            enableScroll();
          }, 1000);
        }
        if (event.deltaY < 0 && canToggleUp) {
          disableScroll();
          canToggleUp = false;
          toggleShow('up');
          setTimeout(() => {
            enableScroll();
          }, 1500);
        }
      } else {
        inSide = false;
      }
    });
  }

  function navHover() {
    const linkDom = document.querySelector('.header__desktop__button');
    const dropdownDom = document.querySelector(
      '.header__desktop__button .nav-dropdown'
    );

    linkDom.addEventListener('mouseenter', (e) => {
      if (dropdownDom) {
        dropdownDom.classList.add('show');
      }
    });

    dropdownDom && dropdownDom.addEventListener('mouseout', (e) => {
      dropdownDom.classList.add('show');
    });

    linkDom.addEventListener('mouseout', (e) => {
      // 判断是否在linkDom内
      const rect = linkDom.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;
      const isInside =
        mouseX >= 0 &&
        mouseX <= linkDom.offsetWidth &&
        mouseY >= 0 &&
        mouseY <= linkDom.offsetHeight;

      // 判断是否在dropdownDom内
      if (!dropdownDom) {
        return;
      }
      const dropdownRect = dropdownDom.getBoundingClientRect();
      const dropdownMouseX = e.clientX - dropdownRect.left;
      const dropdownMouseY = e.clientY - dropdownRect.top;
      const isDropdownInside =
        dropdownMouseX >= 0 &&
        dropdownMouseX <= dropdownDom.offsetWidth &&
        dropdownMouseY >= 0 &&
        dropdownMouseY <= dropdownDom.offsetHeight;
      if (!isInside && !isDropdownInside) {
        dropdownDom.classList.remove('show');
      }
    });
  }

  function compareHeight() {
    // 获取屏幕宽度
    const dom = document.querySelector('.compare_box');

    if (!dom) return;
    const compare = dom.querySelectorAll('.compare_item');
    const compareItems = dom.querySelectorAll('.compare_item_params');
    const group = compareItems.length / compare.length;
    if (compare.length === 1) {
      return;
    }

    const screenWidth = document.documentElement.clientWidth;
    if (screenWidth < 768 && compare.length > 2) {
      compare[2].style.display = 'none';
    }
    for (let i = 0; i < group; i++) {
      if (compare.length === 2) {
        const height1 = compareItems[i].offsetHeight;
        const height2 = compareItems[i + group].offsetHeight;
        if (height1 !== height2) {
          const maxHeight = Math.max(height1, height2);
          compareItems[i].style.height = maxHeight + 'px';
          compareItems[i + group].style.height = maxHeight + 'px';
        }
      }

      if (compare.length === 3) {
        // 判断compareItems[i] compareItems[i+13] compareItems[i+13+13]的高度是否一致
        const height1 = compareItems[i].offsetHeight;
        const height2 = compareItems[i + group].offsetHeight;
        const height3 = compareItems[i + group + group].offsetHeight;
        if (height1 !== height2 || height1 !== height3) {
          const maxHeight = Math.max(height1, height2, height3);
          compareItems[i].style.height = maxHeight + 'px';
          compareItems[i + group].style.height = maxHeight + 'px';
          compareItems[i + group + group].style.height = maxHeight + 'px';
        }
      }

      if (compare.length === 4) {
        // 判断compareItems[i] compareItems[i+13] compareItems[i+13+13]的高度是否一致
        const height1 = compareItems[i].offsetHeight;
        const height2 = compareItems[i + group].offsetHeight;
        const height3 = compareItems[i + group + group].offsetHeight;
        const height4 = compareItems[i + group + group + group].offsetHeight;
        if (height1 !== height2 || height1 !== height3 || height1 !== height4) {
          const maxHeight = Math.max(height1, height2, height3, height4);
          compareItems[i].style.height = maxHeight + 'px';
          compareItems[i + group].style.height = maxHeight + 'px';
          compareItems[i + group + group].style.height = maxHeight + 'px';
          compareItems[i + group + group + group].style.height = maxHeight + 'px';
        }
      }
    }
  }

  function blog() {
    const dom = document.querySelector('.blog__mobile__now');
    if (!dom) return;
    const mb = document.querySelector('.blog__mobile');

    dom.addEventListener('click', (e) => {
      e.stopPropagation();
      mb.classList.toggle('blog__mobile__show');
      dom.classList.toggle('blog__mobile__now__show');
    });

    document.addEventListener('click', () => {
      if (mb.classList.contains('blog__mobile__show')) {
        mb.classList.remove('blog__mobile__show');
        dom.classList.remove('blog__mobile__now__show');
      }
    });
  }

  // showSubmenu();
  copySku();
  showFooter();
  combos();
  expore();
  timeline();
  industry();
  ceo();
  navHover();

  // 监听页面尺寸变化;
  window.addEventListener('resize', () => {
    showSubmenu();
    compareHeight();
    blog();
  });
})();
